import React from 'react'

import FOR_LIST from '../../../constants/ForList'

// styles
import { Break, Container, InnerContainer, ListItem, Text, Title, Row, Element, Child, Contact } from '../Home.styled'

// components
import Button from '../../../components/Button/Button'
import BookingModal from '../../../components/BookingModal/BookingModal'
import Discovery from '../../../components/Card/Discovery'
// import DateTime from '../../../components/Card/DateTime'

import TextSvg from '../../../assets/svgs/banner/bigpresent.svg'
// import { usePopupButton } from '../../../hooks/usePopupButton'

const Schedule = () => {
  const [modalOpen, setModalOpen] = React.useState(false)
  return (
    <Container style={{ paddingBottom: '80px' }}>
        <div style={{ width: '80%' }}>
          <img src={TextSvg} alt="Big Present Seen" style={{ maxWidth: '100%', maxHeight: '100%' }}/>
        </div>
        <InnerContainer>
            <Text>
              Schedule a 20 Minute <Break/> No Obligation Discovery <Break/> Call With Us.
            </Text>
            <Row>
                <Element>
                <Title fontmax={'1.7rem'} fontmin={'0.95rem'} style={{ textAlign: 'left', fontWeight: '500', margin: '15px 0' }}>
                    By the end, we’ll have figured out your needs   <Break/>
                    and formulated a plan to take your business   <Break/>
                    to the next level.
                </Title>
                <Text>
                    Who this is for:
                </Text>
                    <ul>
                    {
                        FOR_LIST.map((data, id) => {
                          return (
                            <ListItem key={id}>{data}</ListItem>
                          )
                        })
                    }
                    </ul>
                </Element>
                <Contact>
                    <Discovery/>
                </Contact>
            </Row>
            <Child>
              <Button mode='light' text='BOOK A CALL' clickEvent={() => setModalOpen(true)} />
              <BookingModal open={modalOpen} onClose={() => setModalOpen(false)} />
            </Child>
        </InnerContainer>
    </Container>
  )
}

export default Schedule
